import { ASYNCSTORAGE_TOKEN_STORE_KEY } from '@/src/common/store/useTokenStore'
import { Api } from '@/src/store'
import { z } from 'zod/v4'
import AsyncStorage from '@react-native-async-storage/async-storage'

const BaseAuthTokenResponseSchema = z.object({
  __typename: z.literal('BaseAuthTokenResponseDto').optional(),
  accessToken: z.string(),
  expiresIn: z.number(),
  tokenType: z.string(),
})

const AuthTokenRefreshResponseSchema = z.object({
  __typename: z.literal('AuthTokenResponseDTO').optional(),
  accessToken: z.string(),
  expiresIn: z.number(),
  refreshToken: z.string(),
  tokenType: z.string(),
})

const GetTokenResponseSchema = z.object({
  token: z.union([BaseAuthTokenResponseSchema, AuthTokenRefreshResponseSchema]).optional(),
})

export const AuthenticationApi = Api.enhanceEndpoints({
  addTagTypes: ['getToken'],
}).injectEndpoints({
  endpoints: (build) => ({
    getToken: build.query({
      async queryFn() {
        try {
          const ASYNCSTORAGE_TOKEN_STORE = await AsyncStorage.getItem(ASYNCSTORAGE_TOKEN_STORE_KEY)

          if (ASYNCSTORAGE_TOKEN_STORE) {
            const TokenStore = JSON.parse(ASYNCSTORAGE_TOKEN_STORE)
            return { data: { token: TokenStore.state.tokens } }
          } else {
            return { data: { token: undefined } }
          }
        } catch (error) {
          return { error }
        }
      },
      keepUnusedDataFor: Infinity,
      argSchema: z.void(),
      responseSchema: GetTokenResponseSchema,
      providesTags: ['getToken'],
    }),
  }),
})
